<template>
  <div class="wrap">
    <div class="search mb10">
      <el-row type="flex" justify="space-between" align="middle" class="mb20">
        <div class="title">分包总览</div>
        <div class="btn_box" style="display: flex; ">
          <el-button
            @click="handleConfig"
            class="config-btn"
            type="primary"
            size="small"
            style="cursor: pointer"
            ><img
              class="set-icon"
              src="https://imgcdn.hemiao100.com/static/set-icon.png"
              alt=""
            />分配规则设置</el-button
          >
          <el-button
            @click="redistribution"
            class="config-btn"
            type="primary"
            size="small"
            style="cursor: pointer"
            >
            <i class="set-icon el-icon-refresh" style="font-size: 20px;margin-right: 5px;line-height: 20px;"></i>
            重新分配单量</el-button
          >
        </div>
      </el-row>
      <el-row class="warning-wrap">
        <div class="warning-item">
          <div class="state">·已逾期<span class="desc" style="font-size: 14px;color: #333333;">{{ queryRemainBillStat.A.tips }}单量</span></div>
          <div class="number">
            <img src="https://imgcdn.hemiao100.com/static/delay.png" alt="" />
            <div class="content">
              <span class="value">{{ queryRemainBillStat.A.num }}</span>
              <span class="label">剩余单量</span>
            </div>
          </div>
        </div>
        <div class="warning-item">
          <div class="state">·昨日待处理<span class="desc" style="font-size: 14px;color: #333333;">{{ queryRemainBillStat.B.tips }}单量</span></div>
          <div class="number">
            <img
              src="https://imgcdn.hemiao100.com/static/yesterday.png"
              alt=""
            />
            <div class="content">
              <span class="value">{{ queryRemainBillStat.B.num }}</span>
              <span class="label">剩余单量</span>
            </div>
          </div>
        </div>
        <div class="warning-item">
          <div class="state">·今日待处理<span class="desc" style="font-size: 14px;color: #333333;">{{ queryRemainBillStat.C.tips }}单量</span></div>
          <div class="number">
            <img src="https://imgcdn.hemiao100.com/static/today.png" alt="" />
            <div class="content">
              <span class="value">{{ queryRemainBillStat.C.num }}</span>
              <span class="label">剩余单量</span>
            </div>
          </div>
        </div>
      </el-row>
      <el-table class="billStat-table" :data="billStatList" stripe max-height="400px">
        <el-table-column label="责任人" prop="account"></el-table-column>
        <el-table-column label="已逾期" prop="A"></el-table-column>
        <el-table-column label="昨日待处理" prop="B"></el-table-column>
        <el-table-column label="今日待处理" prop="C"></el-table-column>
        <el-table-column label="手动分配" prop="D"></el-table-column>
      </el-table>
    </div>
    <el-row class="flex-column table-wrap" type="flex" justify="center">
      <el-form inline size="small" style="text-align: left;">
        <el-form-item label="所属账号">
          <el-select v-model="conditions.accountName" clearable filterable>
            <el-option
              v-for="(account, index) in accountList"
              :key="index"
              :label="account.username"
              :value="account.username"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleSearch" type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe class="mb10">
        <el-table-column label="任务包编号" prop="plan_name"></el-table-column>
        <el-table-column
          label="产生时间"
          prop="alloc_time"
          width="200"
        ></el-table-column>
        <el-table-column
          label="总量"
          prop="wait_declare_num"
          width="200"
        ></el-table-column>
        <el-table-column
          label="任务包评级"
          prop="plan_urgency_level"
        ></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.alloc_type === 'adjusting_mode'"
              type="danger"
              >已拆包</el-tag
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="任务包所属账号" prop="alloc_oper_id"></el-table-column> -->
        <el-table-column
          label="任务包所属账号"
          prop="alloc_work_id"
        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleDistribute(scope.row)" type="text"
              >拆包</el-button
            >
          </template>
        </el-table-column></el-table
      >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog
      title="自动分配规则设置"
      :visible.sync="dialogVisible"
      width="1006px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <div class="dialog-content">
        <div class="left">
          <div class="title mb10">规则设置</div>
          <el-form :model="configForm" size="small" label-width="130px">
            <!-- <el-form-item label="关联账号">songxingan<el-button type="text">更换账号</el-button></el-form-item> -->
            <el-form-item label="选择分配方案">
              <el-radio-group v-model="configForm.autoAllocMode">
                <el-radio label="province_code_mode">按省份分配</el-radio>
                <el-radio label="supplier_code_mode">按供应商分配</el-radio>
                <el-radio label="audit_bill_type_mode">按单据类型分配</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="单账号分配上限">
              <el-input-number
                v-model="configForm.number"
                step-strictly
                :controls="false"
              ></el-input-number>
              <div>请输入整数，为了确保单人操作单量范围可控</div>
            </el-form-item>
            <el-form-item label="兜底账号"
              >{{ supervisorAccount }}
              <el-dropdown @command="handleCommand">
                <el-button type="text" class="el-dropdown-link">
                  更换账号<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in workAccountRules"
                    :command="item.id"
                    :key="index"
                    >{{ item.configValue }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
            <div class="btn-wrap">
              <el-button @click="handleSubmit" type="primary" size="small"
                >确定</el-button
              >
            </div>
          </el-form>
        </div>
        <div class="right">
          <div class="title mb10">动态记录</div>
          <div class="log-wrap">
            <div
              class="log-item"
              v-for="(item, index) in memos"
              :key="'item-' + index"
            >
              <div class="step-title">
                {{ item[0] }} <span>调整了规则设置</span>
              </div>
              <div :class="['step-content', item === 3 && 'no-line']">
                <div class="step-wrap">
                  <div
                    class="step-item"
                    v-for="(v, ind) in item.slice(1, item.length - 1)"
                    :key="ind"
                  >
                    <span class="mr10">将</span>{{ v }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 新增账号 -->
    <el-dialog
      title="重新分配"
      :visible.sync="addVisible"
      width="940px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleDialogClose"
      destroy-on-close
    >
      <el-form ref="addForm" :model="addForm" label-width="100px">
        <el-form-item
          label="账号名称"
          prop="accountName"
          :rules="[
            { required: true, message: '请选择账号', trigger: 'change' },
          ]"
        >
          <el-select v-model="addForm.accountName" filterable>
            <el-option
              :disabled="account.username === row.work_oper_id"
              v-for="(account, index) in accountList"
              :key="index"
              :label="account.username"
              :value="account.username"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据类型" prop="type">
          <el-radio-group v-model="addForm.type">
            <el-radio label="month">月结单</el-radio>
            <el-radio label="normal">普通单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商户">
           <el-select
                size="small"
                clearable
                class="mr10"
                placeholder="请选择商户"
                v-model="adjustingStoreCodeList"
                filterable
                remote
                :remote-method="remoteMethod"
              >
                <el-option
                  :label="item.storeName"
                  :value="item.storeCode"
                  v-for="(item) in storeBasicList"
                  :key="item.storeCode"
                >
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="关联省份">
          <hm-base-transfer
            ref="provinceTransfer"
            leftName="可选权益"
            rightName="已选权益"
            :leftOption="leftOption"
            :leftProps="leftProps"
            :rightProps="leftProps"
            compareKey="code"
          ></hm-base-transfer>
        </el-form-item>
        <el-form-item label="关联供货商">
          <div>
            <el-input
              v-model="keyWords"
              class="mr20"
              clearable
              placeholder="请输入供货商名称"
            ></el-input
            ><el-button @click="queryList" type="primary">查询</el-button>
          </div>
          <hm-base-transfer
            ref="providerTransfer"
            leftName="可选权益"
            rightName="已选权益"
            :leftOption="leftOption2"
            :leftProps="leftProps2"
            :rightProps="leftProps2"
            compareKey="storeCode"
          ></hm-base-transfer>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="handledistrConfirm" type="primary" size="small"
          >确定</el-button
        >
        <el-button @click="addVisible = false" size="small">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import HmBaseTransfer from "@/components/HmBaseTransfer";
export default {
  name: "",
  components: { HmBaseTransfer },
  mixins: [],
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      conditions: {
        accountName: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      configForm: {
        autoAllocMode: "province_code_mode",
        number: undefined,
      },
      queryRemainBillStat: {
        A: 0,
        B: 0,
        C: 0,
      },
      workAccountRules: [],
      supervisorAccountRules: [],
      accountWorkUpperLimitRules: [],
      allocPlanRule: [],
      account: null,
      supervisorAccount: "",
      workUpperLimitRules: [],
      addForm: {
        accountName: "",
        type: "",
        province: "",
        provider: "",
      },
      addVisible: false,
      // 省份
      leftProps: [
        {
          name: "省份",
          value: "name",
        },
      ],
      leftOption: [],
      provinceList: [],

      leftProps2: [
        {
          name: "供货商名称",
          value: "name",
        },
      ],
      leftOption2: [],
      allSupplier: [],
      keyWords: "",
      accountList: {},
      row: {},
      memos: [],
      billStatList: [],
      storeBasicList: [],
      allStoreBasicList: [],
      adjustingStoreCodeList:''
    };
  },
  created() {
    this.init();
    this.getTable();
    this.getAccountList();
    this.queryList();
    this.queryAccountRemainBillStat();
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 重新分配
    redistribution(){
      this.$store.dispatch("dailyAutoAllocPlanJob",{
        operUsername: sessionStorage.getItem("userName")
      })
    },
    handleCommand(command) {
      console.log("--command--", command);
      this.account = this.workAccountRules.find((item) => item.id === command);
      this.supervisorAccount = this.account.configValue;
    },
    /**
     * @desc 获取配置详情
     */
    async initConfig() {
      const { code, result } = await this.$store.dispatch(
        "queryAutoAllocConfig"
      );
      if (code === "0") {
        this.supervisorAccount = result.supervisorAccount;
        this.configForm.number =
          result.workUpperLimitRules && result.workUpperLimitRules.length
            ? result.workUpperLimitRules[0].configValue
            : undefined;
        this.configForm.autoAllocMode = result.autoAllocMode;
        this.workUpperLimitRules = result.workUpperLimitRules;
        this.memos = result.memos.map(
          (item) => {
            item = item.split("\r\n");
            return item;
          }
          // item.replace(new RegExp("\r\n", "g"), "<br>")
        );
        console.log("--this.memos--", this.memos);
      }
    },
    /**
     * @desc 获取配置可选项
     */
    async init() {
      const queryRemainBillStat = await this.$store.dispatch(
        "queryRemainBillStat"
      );
      console.log("--queryRemainBillStat--", queryRemainBillStat);
      this.queryRemainBillStat = queryRemainBillStat.result;
      const { result } = await this.$store.dispatch("obtainAutoAllocRules");
      console.log("---result---", result);
      this.supervisorAccountRules = result.supervisorAccountRules[0];
      this.workAccountRules = result.workAccountRules;
      this.accountWorkUpperLimitRules = result.accountWorkUpperLimitRules;
      this.allocPlanRule = result.allocPlanRule;
    },
    async getAccountList() {
      const { code, result } = await this.$store.dispatch("queryEmployeeList", {
        pageNo: 1,
        pageSize: 9999,
        queryKey: "",
        orgCode: "",
        workingState: "yes",
        syncFlag: "",
        loginType: "store",
      });
      console.log("---code---", code);
      console.log("---result---", result);
      this.accountList = result.records;
    },
    handleAddAccount() {},
    handleDistribute(row) {
      console.log(row);
      this.$set(this, "row", row);
      this.leftOption = [];
      this.leftOption2 = [];
      this.allSupplier = [];
      let params = {
        planId: row.plan_id,
        adjustingOperId: row.alloc_oper_id,
        adjustingWorkId: row.alloc_work_id,
      };
      this.$store
        .dispatch("supplierWorkPlanqueryWorkStatById", {
          id: row.plan_id,
        })
        .then((res) => {
          console.log("--res---", res);
          const {
            billTypeWorkStatList,
            provinceWorkStatList,
            suppliereWorkStatList,
          } = res.result;
          // this.addForm.type = billTypeWorkStatList[0].code;
          this.leftOption = provinceWorkStatList;
          // this.provinceList = provinceWorkStatList;
          this.leftOption2 = suppliereWorkStatList;
          this.allSupplier = suppliereWorkStatList;
        });
      this.queryStoreBasicList();
      this.addVisible = true;
    },
    handledistrConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const province = this.$refs.provinceTransfer.rightChecked;
          const provider = this.$refs.providerTransfer.rightChecked;
          let params = {
            planId: this.row.plan_id,
            // adjustingOperId: this.row.alloc_oper_id,
            adjustingStoreCodeList: this.adjustingStoreCodeList?[this.adjustingStoreCodeList]:[],
            adjustingWorkId: this.addForm.accountName,
            adjustingBillTypeList: [this.addForm.type],
            adjustingProvinceCodeList: province.map((item) => item.code),
            adjustingSupplierCodeList: provider.map((item) => item.code),
          };
          if (!this.addForm.type) {
            delete params.adjustingBillTypeList;
          }
          if (
            !params.adjustingProvinceCodeList ||
            !params.adjustingProvinceCodeList.length
          ) {
            delete params.adjustingProvinceCodeList;
          }
          if (
            !params.adjustingSupplierCodeList ||
            !params.adjustingSupplierCodeList.length
          ) {
            delete params.adjustingSupplierCodeList;
          }
          console.log(params);
          this.$store.dispatch("adjustingWorkload", params).then((res) => {
            this.addVisible = false;
            this.$message.success("操作成功！");
          });
        }
      });
    },
    handleDialogClose() {
      this.addForm = {
        accountName: "",
        type: "",
        province: "",
        provider: "",
      };
      this.adjustingStoreCodeList = ''
    },
    queryList() {
      this.leftOption2 = this.allSupplier.filter(
        (item) => item.name.indexOf(this.keyWords) > -1
      );
    },
    handleSearch() {
      console.log(this.conditions);
      this.page.pageNo = 1;
      this.page.pageSize = 10;
      this.getTable();
    },
    /**
     * @desc 获取表格数据
     */
    getTable() {
      this.$store
        .dispatch("querySupplierWorkPlanList", {
          // account: "hongbao002",
          accountName: this.conditions.accountName,
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        })
        .then((res) => {
          if (res.result && res.result.records) {
            this.tableData = res.result.records;
            this.total = res.result.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        });
    },
    /**
     * @desc 条数改变
     */
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getTable();
    },
    /**
     * @desc 翻页
     */
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getTable();
    },
    handleConfig() {
      this.initConfig();
      this.dialogVisible = true;
    },
    /**
     * @desc 配置提交
     */
    handleSubmit() {
      let workUpperLimitRules = this.workAccountRules.map((item) => {
        const find = this.workUpperLimitRules.find(
          (v) => item.configValue === v.workValue
        );
        console.log(find);
        if (find) {
          return { ...find, configValue: this.configForm.number };
        } else {
          return {
            configType: "work_upper_limit",
            configValue: this.configForm.number,
            workType: "user_name",
            workValue: item.configValue,
          };
        }
      });
      let params = {
        autoAllocMode: this.configForm.autoAllocMode,
        supervisorAccount: this.supervisorAccount,
        workUpperLimitRules,
      };
      this.$store.dispatch("modifyAutoAllocConfig", params).then((res) => {
        if (res.code === "0") {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.handleSearch();
        }
      });
    },
    /**
     * @desc 获取人员统计
     */
    queryAccountRemainBillStat() {
      this.$store.dispatch("queryAccountRemainBillStat", {
        pageNo: 1,
        pageSize: 999,
      }).then((res) => {
        console.log("---res---", res);
        this.billStatList = res.result.records.map((item) => {
          item.planUrgencyLevelWaitBillStat.forEach((v) => {
            item[v["planUrgencyLevel"]] = v["billNum"];
          });
          return item;
        });
      });
    },
    // 商户筛选
    remoteMethod(query) {
      if (query !== '') {
        this.storeBasicList = this.allStoreBasicList.filter(v => v.storeName.indexOf(query) > -1);
      } else {
        this.storeBasicList = [];
      }
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allStoreBasicList = result || [];
    },
  },
};
</script>
<style lang='scss' scoped>
.wrap {
  .search {
    padding: 18px 30px;
    background: #fff;
  }
  .set-icon {
    width: 20px;
    height: 20px;
  }
  .title {
    height: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #222222;
    line-height: 19px;
    position: relative;
    &::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 14px;
      margin-right: 7px;
      background: #e50065;
      border-radius: 2px 0px 2px 0px;
      vertical-align: middle;
    }
  }
  .config-btn {
    padding: 4px 15px;
    /deep/ span {
      display: flex;
      align-items: center;
      img {
        margin-right: 8px;
      }
    }
  }
  .warning-wrap {
    display: flex;
    .warning-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 512px;
      height: 160px;
      padding: 15px;
      margin-right: 19px;
      border-radius: 8px 8px 8px 8px;
      border: 4px solid #e33e3e;
      border-bottom: unset;
      border-left: unset;
      border-right: unset;
      color: #ff8e4f;
      border-color: #ff8e4f;
      background: #fff3ec;
      &:first-of-type {
        color: #e33e3e;
        background: linear-gradient(90deg, #fff3f4 0%, #ffeef0 78%);
      }
      &:last-of-type {
        margin-right: 0;
        color: #20b382;
        border-color: #00a870;
        background: #ebfff8;
      }
      .state {
        position: absolute;
        position: absolute;
        top: 15px;
        left: 15px;
        .desc {
          margin-left: 4px;
          height: 17px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: rgba(34, 34, 34, 0.5);
          line-height: 14px;
        }
      }

      .number {
        display: flex;
        align-items: center;
        img {
          width: 70px;
          height: 70px;
          margin-right: 20px;
        }

        .content {
          display: flex;
          flex-direction: column;
          .value {
            width: 53px;
            height: 52px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 44px;
            // color: #e33e3e;
            line-height: 52px;
          }
          .label {
            height: 22px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 19px;
          }
        }
      }
    }
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .table-wrap {
    padding: 20px 30px;
    background: #fff;
    text-align: center;
  }
}
.dialog-content {
  display: flex;
  .left {
    flex: 3;
    .btn-wrap {
      text-align: right;
      padding-right: 60px;
    }
  }

  .right {
    flex: 2;
    max-height: 500px;
    .log-wrap {
      height: calc(100% - 40px);
      overflow: auto;
      padding-right: 5px;
      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ccc;
      }
      &::-webkit-scrollbar {
        width: 8px; //修改滚动条宽度
      }
      &::-webkit-scrollbar-track {
        border-radius: 8px;
        background: #f3f3f3;
      }
      .log-item {
        margin-bottom: 4px;
        .step-title {
          position: relative;
          padding-left: 24px;
          height: 24px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.9);
          line-height: 24px;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 24px;
          }
          &::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 100px 100px 100px 100px;
            border: 2px solid #e50065;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }

        .step-content {
          padding-left: 24px;
          padding-top: 4px;
          position: relative;
          // padding: 8px 0 8px 24px;
          &::before {
            content: "";
            display: block;
            height: 100%;
            width: 2px;
            position: absolute;
            left: 5px;
            top: 0;
            background: #dcdcdc;
          }
          .step-wrap {
            padding: 8px;
            // width: 336px;
            // height: 68px;
            background: #f3f3f3;
            border-radius: 3px 3px 3px 3px;
            .step-item {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.6);
              line-height: 22px;
              margin-bottom: 8px;
              &:last-of-type {
                margin-bottom: 0;
              }
            }
          }
          .mr10 {
          }

          .primary.mr10 {
          }

          .primary {
          }
        }
        .no-line {
          &::before {
            display: none;
          }
        }
      }
    }
  }
}
.billStat-table {
  margin-top: 20px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #dcdcdc;
  /deep/ .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 6px;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      width: 6px;
      background: rgba(144, 147, 153, 0.3);
    }
  }
}
</style>
